/**
 * This constants are used to create an error message to
 * the alarms service.
 */
 export const carDataDoesNotMatch = `Car data received doesn't match`;
 export const changeOrSelectedErrorSubject = 'Error in selection or change of options.';
 
 /**
  * This constants is used to validate and create an error message 
  * for the required data from the back-end services.
  */
 export const serviceReplace = '{service}';
 export const dataResponseNotAllowedMessage = `The received data from ${serviceReplace} is not allowed.`;
 export const financialPropsRequired = [
    'id',
    'name',
    'financialProductTypeId',
    'legalTerms',
    'summary',
    'description',
    'productDurations',
];
export const productDurationsPropsRequired = [
    'id',
    'duration',
    'maximumDownPayment',
    'minimumDownPayment'
];
export const trimLineDetailsPropsRequired = [
    'id',
    'name',
    'retailPrice'
];
export const trimLineUsedDetailsPropsRequired = ['id', 'name'];
export const vehicleCatalogsPropsRequired = [
    'trimLines',
    'trimLineDetails'
];
